function getReactNativePersistence(storage) {
  const STORAGE_AVAILABLE_KEY = '__sak';
  const LOCAL = 'LOCAL';

  function Persistence() {}

  // Static property (older syntax compatible)
  Persistence.type = LOCAL;

  // Instance property
  Persistence.prototype.type = LOCAL;

  Persistence.prototype._isAvailable = async function () {
    try {
      if (!storage) {
        return false;
      }
      await storage.setItem(STORAGE_AVAILABLE_KEY, '1');
      await storage.removeItem(STORAGE_AVAILABLE_KEY);
      return true;
    } catch (e) {
      return false;
    }
  };

  Persistence.prototype._set = function (key, value) {
    return storage.setItem(key, JSON.stringify(value));
  };

  Persistence.prototype._get = async function (key) {
    const json = await storage.getItem(key);
    return json ? JSON.parse(json) : null;
  };

  Persistence.prototype._remove = function (key) {
    return storage.removeItem(key);
  };

  Persistence.prototype._addListener = function (_key, _listener) {
    return;
  };

  Persistence.prototype._removeListener = function (_key, _listener) {
    return;
  };

  return Persistence;
}

export { getReactNativePersistence };
